
(function() {
  var result = { translations: { "en-gb": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en-gb": "static-7.1241"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1241",
    "ar-eg": "static-7.1241",
    "bg": "static-7.1241",
    "bn": "static-7.1241",
    "ca-es": "static-7.1241",
    "cs": "static-7.1241",
    "da": "static-7.1241",
    "de": "static-7.1241",
    "el": "static-7.1241",
    "en-gb": "static-7.1241",
    "en": "static-7.1241",
    "es-mx": "static-7.1241",
    "es": "static-7.1241",
    "et": "static-7.1241",
    "fi": "static-7.1241",
    "fr-ca": "static-7.1241",
    "fr": "static-7.1241",
    "he-il": "static-7.1241",
    "hi": "static-7.1241",
    "hr": "static-7.1241",
    "hu": "static-7.1241",
    "id": "static-7.1241",
    "it": "static-7.1241",
    "ja": "static-7.1241",
    "ko": "static-7.1241",
    "lt": "static-7.1241",
    "ms": "static-7.1241",
    "nl": "static-7.1241",
    "no": "static-7.1241",
    "pl": "static-7.1241",
    "pt-br": "static-7.1241",
    "pt-pt": "static-7.1241",
    "ro": "static-7.1241",
    "ru": "static-7.1241",
    "sk": "static-7.1241",
    "sl": "static-7.1241",
    "sv": "static-7.1241",
    "th": "static-7.1241",
    "tl": "static-7.1241",
    "tr": "static-7.1241",
    "uk": "static-7.1241",
    "vi": "static-7.1241",
    "x-pseudo": "static-7.1241",
    "zh-cn": "static-7.1241",
    "zh-hk": "static-7.1241",
    "zh-tw": "static-7.1241"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en-gb', {version: 'static-7.1241'}); }
})();


